import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, HostBinding, Input, OnChanges, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { VariantColorModel } from '@models/variant-color';
import { SelectBoxItemComponent } from './select-box-item/select-box-item';

@Component({
    selector: 'select-box',
    templateUrl: 'select-box.html',
    styleUrls: ['./select-box.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SelectBoxItemComponent, CommonModule]
})
export class SelectBoxComponent<T> implements AfterViewInit, OnChanges {

	@HostBinding("class.expanded") @Input() expanded: boolean;

	@Input() imageClass: string;
	@Input() options?: Array<T | null>;
	@Input() optionsText: string;
	@Input() optionsDescription2: string;
	@Input() optionsId: string;
	@Input() optionsImage?: (option: T, p: string | null) => string;
	@Input() optionsDiscontinued: string;
	@Input() selected: any = null;
	@Input() optionsCaption: string | null = null;
	@Input() editMode: boolean;
	@Input() colorMatchMode: boolean;
	@Input() currentColor?: VariantColorModel | null;
	@Input() colorsAvailableForMatching: Array<VariantColorModel>;
	@Input() variantOrModelIsNew: boolean = false;
	@Input() matchColor: number = 0;

	@Input() isAccordion: boolean;

	@Output() matchColors: EventEmitter<null> = new EventEmitter();
	@Output() selectedChange = new EventEmitter<T>();

	public shownOptions?: Array<any> = [];

	constructor() {
	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.scrollIntoView();
		}, 500);
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['options'])
			this.shownOptions = this.options;
	}

	public addClass(input: string): string {
		return input;
	}

	public matchColorsClicked() {
		this.matchColors.emit();
	}

	public setSelected(selected: any) {
		if (selected != this.selected) {
			this.selectedChange.emit(selected);
		}
	}

	public optionIsSelected(option: any) {
		if (option) {
			if (option.hasOwnProperty('Uuid')) {
				if (this.selected) {
					if (this.selected.hasOwnProperty('Uuid')) {
						if (this.selected['Uuid'] === option['Uuid']) {
							return true;
						}
					}
				}
			}
		}

		return false;
	}

	public optionIsSelected2(option: any) {
		if (option) {
			if (option.hasOwnProperty(this.optionsId)) {
				if (this.selected) {
					if (this.selected.hasOwnProperty(this.optionsId)) {
						if (this.selected[this.optionsId] === option[this.optionsId]) {
							return true;
						}
					}
				}
			}
		}

		return false;
	}

	private scrollIntoView() {
		if (this.selected && this.selected.Uuid) {
			const parent = document.getElementById('select-box-container');

			if (parent) {
				const item = parent.querySelector('[id="' + this.selected.Uuid + '"]');

				if (item) {
					item.scrollIntoView(false);
				}
			}
		}
	}

}
